<template>
  <div class="medical-page">
    <medical-top-bar
      search-placeholder="搜索分类、药品、疾病名称"
      :search-value.sync="searchKeyword"
      @search="onSearch"
    />
    <main class="page-layout">
      <div
        v-if="searchKeyword && filteredDepartments.length === 0"
        class="empty-result"
      >
        <p>未找到匹配的结果</p>
      </div>
      <section v-else class="page-main">
        <article
          v-for="department in filteredDepartments"
          :key="department.department_id"
          class="category-card"
        >
          <div class="category-card__header">
            <h3 class="category-card__title">
              {{ department.department_name }}
            </h3>
            <span class="category-card__count">
              {{ department.filteredItems.length }} 项
            </span>
          </div>
          <div class="tag-grid">
            <router-link
              v-for="item in department.filteredItems"
              :key="item.id"
              :to="{ path: '/disease-detail', query: { id: item.id, department_name: department.department_name, name: item.name,  } }"
              class="tag-chip"
            >
              <span class="tag-chip__dot"></span>
              <span v-html="highlightText(item.name)"></span>
            </router-link>
          </div>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
import MedicalTopBar from "./components/MedicalTopBar.vue";
import axios from "axios";

export default {
  name: "MedicalAllCategoryClean",
  components: {
    MedicalTopBar,
  },
  data() {
    return {
      departments: [],
      loading: false,
      searchKeyword: "",
    };
  },
  computed: {
    filteredDepartments() {
      const keyword = this.searchKeyword.trim().toLowerCase();
      if (!keyword) {
        return this.departments.map((dept) => ({
          ...dept,
          filteredItems: dept.items,
        }));
      }

      return this.departments
        .map((dept) => {
          const matchesDeptName = dept.department_name
            .toLowerCase()
            .includes(keyword);
          const filteredItems = dept.items.filter((item) =>
            item.name.toLowerCase().includes(keyword),
          );

          if (matchesDeptName) {
            return { ...dept, filteredItems: dept.items };
          }

          if (filteredItems.length > 0) {
            return { ...dept, filteredItems };
          }

          return null;
        })
        .filter(Boolean);
    },
  },
  mounted() {
    this.fetchDepartments();
  },
  methods: {
    async fetchDepartments() {
      this.loading = true;
      try {
        const response = await axios.get(
          "http://192.168.10.13:8087/ug/disease-department/list",
        );
        if (response.data && response.data.data) {
          this.departments = response.data.data;
        }
      } catch (error) {
        console.error("获取科室列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch(keyword) {
      this.searchKeyword = keyword;
    },
    highlightText(text) {
      if (!this.searchKeyword.trim()) return text;
      const regex = new RegExp(
        `(${this.escapeRegex(this.searchKeyword.trim())})`,
        "gi",
      );
      return text.replace(regex, '<mark class="highlight">$1</mark>');
    },
    escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    },
  },
};
</script>
<style scoped>
.medical-page {
  --accent-color: #0f766e;
  --accent-color-light: #0f766d9a;
  --accent-soft: rgba(15, 118, 110, 0.12);
  --accent-line: rgba(15, 118, 110, 0.2);
  min-height: 100vh;
  background: linear-gradient(180deg, #f0fdf4 0%, #f8fafc 50%, #ffffff 100%);
  color: #0f172a;
}

.page-layout {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 20px 40px;
}

.page-main {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.category-card {
  position: relative;
  padding: 20px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.category-card:hover {
  box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08);
  transform: translateY(-2px);
}

.category-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: var(--accent-color-light);
  border-radius: 16px 0 0 16px;
}

.category-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
}

.category-card__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #10141b;
}

.category-card__count {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 20px;
  background: var(--accent-soft);
  color: var(--accent-color);
  font-size: 12px;
  font-weight: 600;
}

.tag-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.06);
  color: #10141b;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.15s ease;
}

.tag-chip__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent-color);
  flex-shrink: 0;
}

.tag-chip:hover {
  background: var(--accent-color);
  border-color: var(--accent-color);
  color: #ffffff;
}

.tag-chip:hover .tag-chip__dot {
  background: #ffffff;
}

.highlight {
  background: var(--accent-soft);
  color: var(--accent-color);
  padding: 0 2px;
  border-radius: 2px;
}

.empty-result {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}

.empty-result p {
  margin: 0;
  font-size: 16px;
}

@media (max-width: 768px) {
  .page-layout {
    padding: 16px 12px 32px;
  }

  .page-main {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .category-card {
    padding: 16px;
    border-radius: 12px;
  }

  .tag-chip {
    height: 36px;
    padding: 0 14px;
    font-size: 14px;
  }
}
</style>
